var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"rounded-2xl bg-white p-4 shadow-[0px_4px_32px_rgba(0,_0,_0,_0.04)] sm:p-6"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }